import { CircularProgress } from "@mui/material";
import { useChangePasswordData } from "./hooks";
import { InputField } from "../../../../Shared/Radix/Inputs/InputField";
import { PasswordField } from "../../../../Shared/Radix/Inputs/PasswordField";
import InfoMessage from "../../../../Shared/InfoMessage/InfoMessage";
import { USERPASSWORD_MAXLENGTH } from "../../../../../globals/globals";
import { Button } from "../../../../ui/button";
import { Sheet } from "../../../../ui/sheet";

const ChangePassword: React.FC<any> = ({ cancelHandler, isReset }) => {
    const {
        userData,
        onChangeHandler,
        onBlurHandler,
        onSubmitHandler,
        errMsg,
        isSaveDisabled,
        passwordSettings,
        password,
        newPassword,
        confirmPassword,
        savingLoader
    } = useChangePasswordData();

    const handleChange = (name: string, value: string) => {
        onChangeHandler({ preventDefault: () => {}, target: { name, value } });
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        onBlurHandler(e);
    };

    const footer = (
        <>
            <Button variant="outline" onClick={cancelHandler}>
                Cancel
            </Button>
            <Button
                disabled={isSaveDisabled}
                onClick={onSubmitHandler}
            >
                {savingLoader && <CircularProgress size={16} />}
                Submit
            </Button>
        </>
    );

    return (
        <Sheet open={true} onClose={cancelHandler} title={isReset ? "Reset Password" : "Change Password"} footer={footer} width="420px">
            <form autoComplete="off">
                <div className="space-y-4 pt-2">
                    {!isReset && (
                        <InfoMessage message="Changing your password will log you out immediately. You'll need to log in again with the new password." />
                    )}
                    <InputField
                        label="User Name"
                        name="username"
                        value={userData?.username || ""}
                        onChange={handleChange}
                        disabled
                    />
                    <PasswordField
                        label="Old Password"
                        name={password}
                        value={userData?.password || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        autoFocus={true}
                        required
                        
                    />
                    <PasswordField
                        label="New Password"
                        name={newPassword}
                        value={userData?.newPassword || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required
                        minLength={passwordSettings?.minimumLength ?? 8}
                        maxLength={USERPASSWORD_MAXLENGTH}
                        pattern="^(?=.*[A-Z])(?=.*\d)(?=.*[@#,$%^&*!?])[A-Za-z\d@#,$%^&*!?]+$"
                        patternMsg="Please match the format requested."
                        passwordPolicyTitle={`The password must be at least ${passwordSettings?.minimumLength ?? 8} characters long and include at least one uppercase letter (A-Z), one digit (1-9), and one special non-alphabetic character (e.g.,?!%$#).`}
                        tooltipText={
                            <>
                                Minimum length: {passwordSettings?.minimumLength ?? 8} characters.
                                <br />
                                Supported special characters: (,?!%$#).
                            </>
                        }
                    />
                    <PasswordField
                        label="Confirm Password"
                        name={confirmPassword}
                        value={userData?.confirmPassword || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required
                        minLength={passwordSettings?.minimumLength ?? 8}
                        maxLength={USERPASSWORD_MAXLENGTH}
                        pattern="^(?=.*[A-Z])(?=.*\d)(?=.*[@#,$%^&*!?])[A-Za-z\d@#,$%^&*!?]+$"
                        patternMsg="Please match the format requested."
                        passwordPolicyTitle={`The password must be at least ${passwordSettings?.minimumLength ?? 8} characters long and include at least one uppercase letter (A-Z), one digit (1-9), and one special non-alphabetic character (e.g.,?!%$#).`}
                        tooltipText={
                            <>
                                Minimum length: {passwordSettings?.minimumLength ?? 8} characters.
                                <br />
                                Supported special characters: (,?!%$#).
                            </>
                        }
                    />
                </div>
            </form>
        </Sheet>
    );
};

export default ChangePassword;